import React, {useState, useEffect, useRef} from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import axios, {Axios, AxiosRequestHeaders} from 'axios';
import ConfirmationModal from '../../shared/ConfirmationModal';
import NewconfirmationModal from '../../shared/NewconfirmationModal';
import AllFailureModal from '../../shared/AllFailureModal';
import isEqual from 'lodash/isEqual';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';

interface Companies {
  company_id: string;
  company_name: string;
  team_size: number;
  email: string;
  established_in: string;
  contact_number: string;
  primary_industry: string;
  company_website: string;
  comp_registration_number: string;
  about_company: string;
  country: string;
  state: string;
  city: string;
  address: string;
  zip_code: string;
  facebook: string;
  twitter: string;
  linkedin: string;
  whatsapp: string;
  instagram: string;
  pinterest: string;
}

interface Industry {
  id: number;
  name: string;
}

interface User {
  id: number;
  name: string;
  usertype: string;
}

const CompaniesEdit = () => {
  const { company_id } = useParams<{ company_id: string }>();
  const [company, setCompany] = useState<Companies | null>(null);
  const [loading, setLoading] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [pendingValues, setPendingValues] = useState<Companies | null>(null);
  const [industries, setIndustries] = useState<Industry[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const [users, setUsers] = useState<User[]>([]);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false); /* CHANGED */
const [showSuccessModal, setShowSuccessModal] = useState(false); /* CHANGED */
const [showFailureModal, setShowFailureModal] = useState(false); /* CHANGED */
const [successMessage, setSuccessMessage] = useState(''); /* CHANGED */
const [failureMessage, setFailureMessage] = useState(''); /* CHANGED */
  const [searchTerm2, setSearchTerm2] = useState<string>("");
  const [isDropdownOpen2, setIsDropdownOpen2] = useState<boolean>(false);
  const navigate = useNavigate();
  const dropdownRef = useRef<HTMLDivElement>(null);

  const fetchCompanyById = async (id: string) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}companyDetails/bycompanyid/${id}`;
      const response = await axios.get<Companies[]>(url);

      if (response.data && response.data.length > 0) {
        setCompany(response.data[0]);
        setSearchTerm(response.data[0].primary_industry)
      } else {
        setCompany(null);
      }
    } catch (error) {
      console.error("Error fetching company:", error);
    } finally {
      setLoading(false);
    }
  };

  const filteredIndustries = industries.filter((industry) =>
    industry.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const filteredEmployers = users.filter((user) =>
    user.name.toLowerCase().includes(searchTerm2.toLowerCase())
  );

  const updateCompany = async (values: Companies) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}companyDetails/updatecompany`;
      await axios.put(url, values);
      return { success: true };
    } catch (error) {
      console.error('Error updating company:', error);
      return { success: false };
    }
  };

  const handleUpdateConfirmation = async (isConfirmed: boolean) => {
    setShowConfirmationModal(false);
    if (isConfirmed && pendingValues) {


      const result = await updateCompany(pendingValues);
      if (result.success) {
        setSuccessMessage('Updated successfully!');
        setShowSuccessModal(true);
        setPendingValues(null);
        setTimeout(() => navigate('/companieslist'), 3000);
      } else {
        setFailureMessage('Failed to Update Company.');
      setShowFailureModal(true);
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // const usersResponse = await axios.get<User[]>(`${process.env.REACT_APP_API_URL}users/allusers`, {headers: headers});
        // const employers = usersResponse.data.filter((user) => user.usertype === "employer");
        // setUsers(employers);

        const industriesResponse = await axios.get<Industry[]>(`${process.env.REACT_APP_API_URL}industries/get-all-industries`);
        setIndustries(industriesResponse.data);
          console.log(industriesResponse.data);

      } catch (error) {
        console.error("Failed to fetch data:", error);
      }
    };

    fetchData();
  }, []);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if(dropdownRef.current && !dropdownRef.current.contains(event.target as Node)){
                setIsDropdownOpen(false)
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        }
    }, []);

  useEffect(() => {
    if (company_id) {
      fetchCompanyById(company_id);
    } else {
      setLoading(false);
    }
  }, [company_id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!company) {
    return <div>No company found</div>;
  }

  return (
      <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="shadow">
            <Card.Header className="bg-info text-white text-center">
              <h4>Edit Company</h4>
            </Card.Header>

            <Card.Body>
            <Formik
    enableReinitialize
    initialValues={company}
    onSubmit={(values: Companies) => {
      if (isEqual(values, company)) {  /* CHANGED: No confirmation, show success modal directly */
        setSuccessMessage('No updates made.');
        setShowSuccessModal(true);
      } else {
        setPendingValues(values);
        setModalMessage('Are you sure you want to update the company details?');
        setShowConfirmationModal(true);
      }
    }}
  >
                {({ setFieldValue, values }) => (
                  <Form className="CompaniesEditForm">
            <div className="row">
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label className="form-label">Company Name:</label>
                                      <Field name="company_name">
                                        {({ field, form }: { field: any; form: any }) => (
                                          <div className="dropdown">
                                            <input
                                              type="text"
                                              placeholder="Search Company"
                                              value={values.company_name}
                                              onChange={(e) => {
                                                setSearchTerm2(e.target.value);
                                                setIsDropdownOpen2(!!e.target.value);
                                              }}
                                              onFocus={() => setIsDropdownOpen2(!!searchTerm2)}
                                              className="form-control mb-3"
                                            />
                                            {isDropdownOpen2 && searchTerm2 && (
                                              <div className="dropdown-menu show w-100">
                                                {filteredEmployers.length > 0 ? (
                                                  filteredEmployers.map((user) => (
                                                    <div
                                                      key={user.id}
                                                      className="dropdown-item cursor-pointer"
                                                      onClick={() => {
                                                        form.setFieldValue(field.name, user.name);
                                                        setSearchTerm2(user.name);
                                                        setIsDropdownOpen2(false);
                                                      }}
                                                    >
                                                      {user.name}
                                                    </div>
                                                  ))
                                                ) : (
                                                  <div className="dropdown-item no-results">No results found</div>
                                                )}
                                              </div>
                                            )}
                                          </div>
                                        )}
                                      </Field>
                                      <ErrorMessage name="company_name" component="div" className="text-danger" />
                                    </div>
                                  </div>

                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label className="form-label">Email:</label>
                                      <Field
                                        type="email"
                                        name="email"
                                        className="form-control mb-3"
                                        placeholder="Enter Email"
                                      />
                                      <ErrorMessage name="email" component="div" className="text-danger" />
                                    </div>
                                  </div>
                                </div>

                                <div className="row">
                                                      <div className="col-md-6">
                                                        <div className="form-group">
                                                          <label className="form-label">Contact Number:</label>
                                                          <Field
                                                            type="text"
                                                            name="contact_number"
                                                            className="form-control mb-3"
                                                            placeholder="Enter Contact Number"
                                                          />
                                                          <ErrorMessage name="contact_number" component="div" className="text-danger" />
                                                        </div>
                                                      </div>
                                                      <div className="col-md-6">
                                                        <div className="form-group">
                                                          <label className="form-label">Registration Number:</label>
                                                          <Field
                                                            type="text"
                                                            name="comp_registration_number"
                                                            className="form-control mb-3"
                                                            placeholder="Enter Registration Number"
                                                          />
                                                          <ErrorMessage name="comp_registration_number" component="div" className="text-danger" />
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div className="row">
                                                      <div className="col-md-6">
                                                        <div className="form-group">
                                                          <label className="form-label">Website:</label>
                                                          <Field
                                                            type="text"
                                                            name="company_website"
                                                            className="form-control mb-3"
                                                            placeholder="Enter Website URL"
                                                          />
                                                          <ErrorMessage name="company_website" component="div" className="text-danger" />
                                                        </div>
                                                      </div>
                                                      <div className="col-md-6">
                                                        <div className="form-group">
                                                          <label className="form-label">Team Size:</label>
                                                          <Field
                                                            type="text"
                                                            name="team_size"
                                                            className="form-control mb-3"
                                                            placeholder="Enter Team Size"
                                                          />
                                                          <ErrorMessage name="team_size" component="div" className="text-danger" />
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div className="row">
                                                      <div className="col-md-6">
                                                        <div className="form-group">
                                                          <label className="form-label">Established Year:</label>
                                                          <Field
                                                            type="text"
                                                            name="established_in"
                                                            className="form-control mb-3"
                                                            placeholder="Enter Established Year"
                                                          />
                                                          <ErrorMessage name="established_in" component="div" className="text-danger" />
                                                        </div>
                                                      </div>
                                                      <div className="col-md-6">
                                                        <div className="form-group">
                                                          <label className="form-label">Primary Industry:</label>
                                                          <Field name="primary_industry">
                                                          {({ field, form }: { field: any; form: any }) => (
                                                              <div className="dropdown" ref={dropdownRef}>
                                                                <input
                                                                  type="text"
                                                                  placeholder="Search Industry"
                                                                  value={searchTerm}
                                                                  onChange={(e) => {
                                                                    setSearchTerm(e.target.value);
                                                                    setIsDropdownOpen(!!e.target.value);
                                                                  }}
                                                                  onFocus={() => setIsDropdownOpen(true)}
                                                                  className="form-control mb-3"
                                                                />
                                                                {isDropdownOpen && (
                                                                  <div className="dropdown-menu show w-100" style={{maxHeight: 250, overflowY: 'auto'}}>
                                                                    {filteredIndustries.length > 0 ? (
                                                                      filteredIndustries.map((industry) => (
                                                                        <div
                                                                          key={industry.id}
                                                                          className="dropdown-item cursor-pointer"
                                                                          onClick={() => {
                                                                            form.setFieldValue(field.name, industry.name);
                                                                            setSearchTerm(industry.name);
                                                                            setIsDropdownOpen(false);
                                                                          }}
                                                                        >
                                                                          {industry.name}
                                                                        </div>
                                                                      ))
                                                                    ) : (
                                                                      <div className="dropdown-option no-results">No results found</div>
                                                                    )}
                                                                  </div>
                                                                )}
                                                              </div>
                                                            )}
                                                          </Field>
                                                          <ErrorMessage name="primary_industry" component="div" className="text-danger" />
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="row">
                                                      <div className="col-md-6">
                                                        <div className="form-group">
                                                          <label className="form-label">Working Days:</label>
                                                          <Field
                                                            type="text"
                                                            name="working_days"
                                                            className="form-control mb-3"
                                                            placeholder="Enter Working Days"
                                                          />
                                                          <ErrorMessage name="working_days" component="div" className="text-danger" />
                                                        </div>
                                                      </div>
                                                      <div className="col-md-6">
                                                        <div className="form-group">
                                                          <label className="form-label">Working Hours:</label>
                                                          <Field
                                                            type="text"
                                                            name="working_hours"
                                                            className="form-control mb-3"
                                                            placeholder="Enter Working Hours"
                                                          >
                                                          </Field>
                                                          <ErrorMessage name="primary_industry" component="div" className="text-danger" />
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div className="row">
                                                      <div className="col-full">
                                                        <div className="form-group">
                                                          <label className="form-label">About Company:</label>
                                                          <Field
                                                            as="textarea"
                                                            name="about_company"
                                                            className="form-control mb-3"
                                                            rows="5"
                                                            placeholder="Enter a detailed company description..."
                                                          />
                                                          <ErrorMessage name="about_company" component="div" className="text-danger" />
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div className="row">
                                                      <div className="col-full">
                                                        <div className="form-group">
                                                          <label className="form-label">Full Address:</label>
                                                          <Field
                                                            as="textarea"
                                                            name="address"
                                                            className="form-control mb-3"
                                                            rows="3"
                                                            placeholder="Enter full address of company."
                                                          />
                                                          <ErrorMessage name="address" component="div" className="text-danger" />
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div className="row">
                                                      <div className="col-md-6">
                                                        <div className="form-group">
                                                          <label className="form-label">City:</label>
                                                          <Field
                                                            type="text"
                                                            name="city"
                                                            className="form-control mb-3"
                                                            placeholder="Enter City"
                                                          />
                                                          <ErrorMessage name="city" component="div" className="text-danger" />
                                                        </div>
                                                      </div>
                                                    </div>


                                                    <div className="row">
                                                      <div className="col-md-6">
                                                        <div className="form-group">
                                                          <label className="form-label">Facebook:</label>
                                                          <Field
                                                            type="text"
                                                            name="facebook"
                                                            className="form-control mb-3"
                                                            placeholder="Enter Facebook URL"
                                                          />
                                                        </div>
                                                      </div>
                                                      <div className="col-md-6">
                                                        <div className="form-group">
                                                          <label className="form-label">Twitter:</label>
                                                          <Field
                                                            type="text"
                                                            name="twitter"
                                                            className="form-control mb-3"
                                                            placeholder="Enter Twitter URL"
                                                          />
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div className="row">
                                                      <div className="col-md-6">
                                                        <div className="form-group">
                                                          <label className="form-label">LinkedIn:</label>
                                                          <Field
                                                            type="text"
                                                            name="linkedin"
                                                            className="form-control mb-3"
                                                            placeholder="Enter LinkedIn URL"
                                                          />
                                                        </div>
                                                      </div>
                                                      <div className="col-md-6">
                                                        <div className="form-group">
                                                          <label className="form-label">Instagram:</label>
                                                          <Field
                                                            type="text"
                                                            name="instagram"
                                                            className="form-control mb-3"
                                                            placeholder="Enter Instagram URL"
                                                          />
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div className="row">
                                                      <div className="col-md-6">
                                                        <div className="form-group">
                                                          <label className="form-label">WhatsApp:</label>
                                                          <Field
                                                            type="text"
                                                            name="whatsapp"
                                                            className="form-control mb-3"
                                                            placeholder="Enter WhatsApp Number/URL"
                                                          />
                                                        </div>
                                                      </div>
                                                      <div className="col-md-6">
                                                        <div className="form-group">
                                                          <label className="form-label">Pinterest:</label>
                                                          <Field
                                                            type="text"
                                                            name="pinterest"
                                                            className="form-control mb-3"
                                                            placeholder="Enter Pinterest URL"
                                                          />
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div className="row">
                                                      <div className="col-full">
                                                        <div className="form-group">
                                                          <label className="form-label">Company tagline:</label>
                                                          <Field
                                                            type="text"
                                                            name="tagline"
                                                            className="form-control mb-3"
                                                            rows="3"
                                                            placeholder="Enter tagline of company."
                                                          />
                                                          <ErrorMessage name="tagline" component="div" className="text-danger" />
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div className="row">
                                                      <div className="col-md-6">
                                                        <div className="form-group">
                                                          <label className="form-label">Company Logo:</label>
                                                          <input
                                                            type="file"
                                                            name="logo"
                                                            accept="image/png, image/jpeg, image/jpg"
                                                            onChange={(event) => {
                                                              const file = (event.currentTarget as HTMLInputElement).files?.[0] || null;

                                                              if (file) {
                                                                const validTypes = ["image/png", "image/jpeg", "image/jpg"];
                                                                if (validTypes.includes(file.type)) {
                                                                  setFieldValue("logo", file);
                                                                } else {
                                                                  alert("Only JPG, JPEG, and PNG files are allowed.");
                                                                  event.target.value = "";
                                                                }
                                                              }
                                                            }}
                                                            className="form-control mb-3"
                                                          />
                                                          <ErrorMessage name="logo" component="div" className="text-danger" />
                                                        </div>
                                                      </div>
                                                    </div>



            <div className="row">
              <div className="text-center my-4">
                <button type="submit" className="btn btn-success">
                  Update Company
                </button>
                <Link to="/companieslist" className="btn btn-danger ms-3">
                  Go Back
                </Link>
              </div>
            </div>
          </Form>
        )}
      </Formik>
      </Card.Body>
                </Card>
              </Col>
            </Row>

            <ConfirmationModal
  show={showConfirmationModal}
  modalMessage={modalMessage}
  onHide={() => setShowConfirmationModal(false)}
  confirmation={handleUpdateConfirmation}
  operationType="Update"
/>

<NewconfirmationModal
  show={showSuccessModal}
  onHide={() => setShowSuccessModal(false)}
  modalMessage={successMessage}
  operationType="OK"
  timeoutDuration={3000}

/>

<AllFailureModal
  show={showFailureModal}
  onHide={() => setShowFailureModal(false)}
  modalMessage={failureMessage}
  operationType="OK"
  timeoutDuration={3000}
/>
      </Container>
  );
};

export default CompaniesEdit;
